<template>
  <div class="tabbed-code-snippets">
    <v-tabs v-if="$slots['tabs']" connotation="primary" class="tabs">
      <slot name="tabs" />
      <v-tab-panel v-for="(_, i) in tabSlotItems" :key="i" />
    </v-tabs>
    <slot name="content" />
  </div>
</template>

<script setup lang="ts">
import { computed, useSlots } from 'vue';
import { VTabPanel, VTabs } from '@vonage/vivid-vue';

const slots = useSlots();
const tabSlotItems = computed(() => slots.tabs?.() ?? []);
</script>

<style lang="scss">
$background-color: var(--vvd-color-neutral-900);

.tabbed-code-snippets {
  background-color: $background-color;
  border-radius: 15px;
  overflow: hidden;
  --code-snippet-bg-color: var(--vvd-color-neutral-900);

  .code-section {
    margin: 0;
  }

  .tabs {
    --vvd-tab-accent-faint: rgba(255, 255, 255, 0.1);
    --vvd-tab-accent-soft: rgba(255, 255, 255, 0.1);
    --vvd-tab-accent-primary: var(--vvd-color-canvas);
  }
}
</style>
